import { ArticleParagraph1 } from '@cian/ui-kit';

import { FC } from 'react';

export const SpecialistDescription: FC = () => {
  return (
    <ArticleParagraph1 as="span" color="black_100" fontWeight="normal">
      Наш специалист свяжется с вами в течение 2 рабочих дней
    </ArticleParagraph1>
  );
};

SpecialistDescription.displayName = 'SpecialistDescription';
